import {v4 as uuidv4} from 'uuid';
import img1 from '../../assets/img/client/1.jpg';

const TestimonialTwoData = [
    {
        id: uuidv4(),
        img: img1,
        name: 'The Heart Of Our Success',
        // designation: 'Contructor',
        speech: 'Our experience starts at the origin. It’s the heart of our business, where our knowledge and expertise assist farmers to obtain a fair price for their produce, as well as guidance on better crop management practices. This in turn provides us with a consistent supply of good quality products',
    },

    {
        id: uuidv4(),
        img: img1,
        name: 'Leading Technology and Processes',
        // designation: 'CEO, Modina Themes',
        speech: 'We have developed sophisticated ginning capabilities in all of our sourcing origins. Our aim is to produce the highest quality premium grades of cotton for our customers worldwide. We pride ourselves on our flexibility and the ability to customise our processes to meet end user requirements.',
    },
    {
        id: uuidv4(),
        img: img1,
        name: 'Delivering for Our Customers',
        // designation: 'CEO, Modina Themes',
        speech: 'SHREE GITA’s total commitment to delivering for our customers is a founding principle of our company. Our sophisticated marketing, distribution and customer service network has enabled us to build a reputation for exceptional service and reliability.',
    },
    
]

export default TestimonialTwoData;